import afSharePage from "../../../Assets/sharePageFunction";
(function () {
    //Sharing
    const shareButton = document.querySelectorAll(".af-blog-search-mobile-intro-button-share")[0];
    const shareTitle = document.querySelectorAll("#af-blog-search-mobile-intro-text h1")[0];
    window.addEventListener("load",function() {afSharePage(shareButton,shareTitle)});

    //Automatically scrolling
    let holdInterval;
    let automaticScroll = false;
    let automaticScrollLeft = false;
    const filterItems = document.querySelectorAll(".job-overview-filter-wrapper")[0];

    function smoothScrollBy(element, delta, duration = 300) {
        const start = element.scrollLeft;
        const startTime = performance.now();

        function animate(time) {
            const elapsed = time - startTime;
            const progress = Math.min(elapsed / duration, 1);
            element.scrollLeft = start + delta * easeOutQuad(progress);
            if (progress < 1) requestAnimationFrame(animate);
        }

        function easeOutQuad(t) {
            return t * (2 - t);
        }

        requestAnimationFrame(animate);
    }

    function automaticHorizontalScrollRight() {
        smoothScrollBy(filterItems,45);
    }
    function automaticHorizontalScrollLeft() {
        smoothScrollBy(filterItems,-45);
    }

    function automaticHorizontalScroll() {
        if(window.innerWidth < 768) {
            holdInterval = setInterval(function repeat() {
                if(!automaticScrollLeft) {
                    automaticHorizontalScrollRight();
                }
                if(automaticScrollLeft) {
                    automaticHorizontalScrollLeft();
                }
                automaticScrollLeft = !automaticScrollLeft;
            }, 1200);
        }
        else {
            clearInterval(holdInterval);
        }
    }

    function clearHoldInterval() {
        clearInterval(holdInterval);
    }

    window.addEventListener("load",automaticHorizontalScroll);

    filterItems.addEventListener("touchstart",clearHoldInterval)

})();
